import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DeviceDetectionService {
  private readonly MOBILE_BREAKPOINT = 768;

  private isMobileDevice = signal<boolean>(false);

  constructor() {
    this.checkDevice();
    this.setupResizeListener();
  }

  private checkDevice(): void {
    const isMobileByUserAgent = this.checkUserAgent();
    const isMobileByWidth = this.checkScreenWidth();

    this.isMobileDevice.set(isMobileByUserAgent || isMobileByWidth);
  }

  private checkUserAgent(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();

    const mobileKeywords = [
      "android",
      "webos",
      "iphone",
      "ipad",
      "ipod",
      "blackberry",
      "iemobile",
      "opera mini",
      "mobile",
      "tablet",
    ];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
  }

  private checkScreenWidth(): boolean {
    return window.innerWidth < this.MOBILE_BREAKPOINT;
  }

  private setupResizeListener(): void {
    window.addEventListener("resize", () => {
      this.checkDevice();
    });
  }

  isMobile(): boolean {
    return this.isMobileDevice();
  }

  getDeviceSignal() {
    return this.isMobileDevice;
  }
}
